// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1425 ? "2170a4aa" : chunkId) + "." + {"982":"c53069b3c865f3b7","1425":"e83fd64a30227ad9"}[chunkId] + ".js";
};